import { useState, type ReactNode } from 'react'

export interface WorkspaceFormSlot {
  content: ReactNode
  collapsible?: boolean
  collapsed?: boolean
  summary?: ReactNode
  onToggle?: (collapsed: boolean) => void
}

export interface WorkspacePageProps {
  header?: ReactNode
  form?: WorkspaceFormSlot
  toolbar?: ReactNode
  footer?: ReactNode
  children: ReactNode
  className?: string
}

export function WorkspacePage({
  header,
  form,
  toolbar,
  footer,
  children,
  className = '',
}: WorkspacePageProps) {
  const [localCollapsed, setLocalCollapsed] = useState(Boolean(form?.collapsed))
  const collapsed = form?.onToggle ? Boolean(form.collapsed) : localCollapsed
  const canCollapse = Boolean(form?.collapsible || form?.onToggle)

  function toggleForm() {
    const next = !collapsed
    if (form?.onToggle) form.onToggle(next)
    else setLocalCollapsed(next)
  }

  return (
    <div className={`flex h-full min-h-0 w-full min-w-0 flex-col gap-2 ${className}`}>
      {header && <header className="shrink-0">{header}</header>}

      {form && (
        <section className="shrink-0 min-w-0">
          {canCollapse && collapsed ? (
            <div className="flex min-h-10 items-center gap-3 border border-slate-200 bg-white px-3 py-1 text-sm">
              <div className="min-w-0 flex-1 truncate">{form.summary}</div>
              <button type="button" className="shrink-0 text-sky-700 hover:text-sky-900" onClick={toggleForm}>
                ✎ Sửa
              </button>
            </div>
          ) : (
            <>
              {canCollapse && (
                <div className="flex justify-end">
                  <button type="button" className="text-xs text-sky-700 hover:text-sky-900" onClick={toggleForm}>
                    Thu gọn
                  </button>
                </div>
              )}
              {form.content}
            </>
          )}
        </section>
      )}

      {toolbar && <div className="shrink-0">{toolbar}</div>}
      <section className="min-h-0 min-w-0 flex-1 overflow-hidden">{children}</section>
      {footer && <footer className="shrink-0">{footer}</footer>}
    </div>
  )
}
